export var fit = function (width, height, format) { return ({
    type: "fit",
    transformation: "fit",
    width: width,
    height: height,
    format: format !== null && format !== void 0 ? format : "jpg",
}); };
export var fitWidth = function (width, format) { return ({
    type: "fit_width",
    transformation: "fit",
    width: width,
    format: format !== null && format !== void 0 ? format : "jpg",
}); };
export var fitHeight = function (height, format) { return ({
    type: "fit_height",
    transformation: "fit",
    height: height,
    format: format !== null && format !== void 0 ? format : "jpg",
}); };
export var fill = function (width, height, format) { return ({
    type: "fill",
    transformation: "fill",
    width: width,
    height: height,
    format: format !== null && format !== void 0 ? format : "jpg",
}); };
export var focusFill = function (width, height, x, y, format) { return ({
    type: "focus_fill",
    transformation: "focus_fill",
    width: width,
    height: height,
    x: x,
    y: y,
    format: format !== null && format !== void 0 ? format : "jpg",
}); };
